import styled from 'styled-components'
import Image from "react-bootstrap/Image";

export const AccountSummaryContainer = styled.div`
    text-align: center
`

export const StyledImage = styled(Image)`
    height: 200px;
    width: 200px;
`

export const Name = styled.h2`
    margin: 10px;
`

export const Info = styled.p`
    display: inline;
    margin: 5px;
    color: grey;
`

export const InfoContainer = styled.p`
    color: grey;
`
